const ACCESS_TOKEN_KEY = 'access_token'

/** Lưu bearer token từ entry (`/?token=`). */
export const storeAccessToken = (token) => {
  if (!token) return
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)

export const hasAccessToken = () => Boolean(getAccessToken())

/** Xóa session local (logout). */
export const clearAuthSession = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('expires_in')
}
